import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { useCategories } from "../../../categories-context/CategoriesContext";

import { useMarketDifficultyData } from "./common/queries/useMarketDifficultyData";
import MarketDifficulty from "./market-difficulty/MarketDifficulty";

const MarketDifficultyWrapper = styled.div<{ wrapperWidth: string; wrapperHeight: string }>`
    background-color: ${colorsPalettes.carbon[0]};
    height: ${({ wrapperHeight }) => `${wrapperHeight}`};
    width: ${({ wrapperWidth }) => `${wrapperWidth}`};
`;

interface IMarketDifficulty {
    width?: string;
    height?: string;
}

const MarketDifficultyContainer: FC<IMarketDifficulty> = ({ width = "100%", height = "400px" }) => {
    const { categories } = useCategories();
    const primaryCategory = categories[0]?.category;
    const { data, isLoading } = useMarketDifficultyData(primaryCategory ? [primaryCategory] : []);

    const primaryData = data[0];

    return (
        <MarketDifficultyWrapper
            data-automation="MarketDifficulty"
            wrapperWidth={width}
            wrapperHeight={height}
        >
            <MarketDifficulty
                data={primaryData?.Difficulty}
                isLoading={isLoading}
            />
        </MarketDifficultyWrapper>
    );
};

export default MarketDifficultyContainer;
